/**
 * Throws an error indicating that the `isAuthorized` function was not provided to the `PermissionsProvider`.
 *
 * @throws {Error} Always throws an error when called, signaling a missing `isAuthorized` implementation.
 */
export const isAuthorizedUnset = (): never => {
  throw new Error('You did not provide an isAuthorized function to PermissionsProvider');
};
